import { useEffect } from 'react';

import { setDynatraceUser } from '../utils/dynatrace';

let userAuthenticateOnce = false;

export const useSetDynatraceUser = (analyticsId?: string | null): void => {
  useEffect(() => {
    if (analyticsId && !userAuthenticateOnce) {
      setDynatraceUser(analyticsId);
      userAuthenticateOnce = true;
    }
  }, [analyticsId]);
};
